import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, notification, Form, Space,Tooltip, Modal ,Input} from "antd";
import GenericTable from "../components/GenericTable";
import GenericDrawer from "../components/GenericModal";
import GenericViewModal from "../components/GenericViewModal";
import {
  fetchClaimsRequest,
  createClaimRequest,
  updateClaimRequest,
  deleteClaimRequest,
} from "../redux-saga/actions/claimActions";
import { useParams } from "react-router-dom";
import ProjectNavbar from "../components/ProjectNavbar";
import moment from "moment";
import { updateCurrentProjectId } from "../redux-saga/actions/customerActions";
import {fetchInsurancesRequest} from "../redux-saga/actions/insuranceActions";
import {fetchPatientsRequest} from "../redux-saga/actions/patientActions";
import {fetchDiagnosesRequest} from "../redux-saga/actions/diagnosisActions";
import {fetchServicesRequest} from "../redux-saga/actions/serviceActions";
import {fetchVisitsRequest} from "../redux-saga/actions/visitActions";
import {fetchEncountersRequest} from "../redux-saga/actions/encounterActions";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {IconReport} from '@tabler/icons-react';

const ClaimPage = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const claims = useSelector((state) => state.claim.claims?.data);
  const loading = useSelector((state) => state.claim.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingClaim, setEditingClaim] = useState(null);
  const [form] = Form.useForm();
  const [viewingClaim, setViewingClaim] = useState(null);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const insurances = useSelector((state) => state.insurance.insurances?.data);
  const patients = useSelector((state) => state.patient.patients?.data);
  const diagnoses = useSelector((state) => state.diagnosis.diagnoses?.data);
  const services = useSelector((state) => state.service.services?.data);
  const visits = useSelector((state) => state.visit.visits?.data);
  const encounters = useSelector((state) => state.encounter.encounters?.data);

  const metaData = useSelector((state) => state.claim.claims?.meta || {});
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchClaimsRequest(projectId,{ page: currentPage, limit: 2, search: searchTerm }));
    dispatch(updateCurrentProjectId(projectId));
    dispatch(fetchInsurancesRequest(projectId));
    dispatch(fetchPatientsRequest(projectId));
    dispatch(fetchDiagnosesRequest(projectId));
    dispatch(fetchServicesRequest(projectId));
    dispatch(fetchVisitsRequest(projectId));
    dispatch(fetchEncountersRequest(projectId));
  }, [dispatch, projectId,currentPage, searchTerm]);

  const claimModalInputs = [
    { label: "Patient ID", name: "patientId", type: "select",options: patients?.map((patient) => ({
      label: patient.name,
      value: patient.id,
    })), },
    { label: "Insurance ID", name: "insuranceId", type: "select",options: insurances?.map((insurance) => ({
      label: insurance.name,
      value: insurance.id,
    })),},
    { label: "Diagnosis ID", name: "diagnosisId", type: "select",options: diagnoses?.map((diagnose) => ({
      label: diagnose.name,
      value: diagnose.id,
    })), },
    { label: "Service ID", name: "serviceId", type: "select",options: services?.map((service) => ({
      label: service.name,
      value: service.id,
    })), },
    { label: "Visit ID", name: "visitId", type: "select",options: visits?.map((visit) => ({
      label: visit.name,
      value: visit.id,
    })), },
    { label: "Encounter ID", name: "encounterId", type: "select", options: encounters?.map((encounter) => ({
      label: encounter.name,
      value: encounter.id,
    })),},
  ];

  const handleCreateOrEdit = (values) => {
    const payload = {  
      projectId: String(values.projectId),
      patientId: String(values.patientId),
      insuranceId: String(values.insuranceId),
      diagnosisId: String(values.diagnosisId),
      serviceId: String(values.serviceId),
      visitId: String(values.visitId),
      encounterId: String(values.encounterId),           
    };
    if (editingClaim) {
      dispatch(updateClaimRequest(editingClaim.id, payload, projectId));
    } else {
      dispatch(createClaimRequest(payload, projectId));
    }
    notification.success({ message: "Success", description: "Claim saved successfully." });
    setIsModalVisible(false);
    setEditingClaim(null);
    form.resetFields();
  };

  const handleView = (record) => {
    const formattedRecord = {
      ...record,
      createdAt: record.createdAt ? moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss") : null,
      updatedAt: record.updatedAt ? moment(record.updatedAt).format("YYYY-MM-DD HH:mm:ss") : null,
    };
    setViewingClaim(formattedRecord);
    setIsViewModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingClaim(record);
    setIsModalVisible(true);
    form.setFieldsValue(record);
  };

  const handleDelete = (record) => {
  Modal.confirm({
    title: "Confirm",
    content: "Are you sure you want to delete this claim?",
    onOk: () => {
      dispatch(deleteClaimRequest(record.id, projectId));
      notification.success({ message: "Success", description: "Claim deleted successfully." });
    },
  });
  };

  const columnsConfig = [
    { title: "Patient ID", dataIndex: "patientId" },
    { title: "Insurance ID", dataIndex: "insuranceId" },
    { title: "Diagnosis ID", dataIndex: "diagnosisId" },
    { title: "Service ID", dataIndex: "serviceId" },
    { title: "Visit ID", dataIndex: "visitId" },
    { title: "Encounter ID", dataIndex: "encounterId" },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View">
            <EyeOutlined style={{ fontSize: "20px", color: "#1890ff" }} onClick={() => handleView(record)} />
          </Tooltip>
          <Tooltip title="Edit">
            <EditOutlined style={{ fontSize: "20px", color: "#faad14" }} onClick={() => handleEdit(record)} />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined style={{ fontSize: "20px", color: "#f5222d" }} onClick={() => handleDelete(record)} />
          </Tooltip>
        </Space>
      ),
    },
    
  ];
  // const actions = ["View", "Edit", "Delete"];
  // const actionFunctions = [
  //   (record) => handleView(record),
  //   (record) => handleEdit(record),
  //   (record) => handleDelete(record),
  // ];

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <ProjectNavbar />
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
              <IconReport style={{ fontSize: "24px", color: "black" }} />
                <h2 style={{ margin: 0 }}>Claim</h2>
            </div>

            <div style={{ display: "flex", justifyContent: "end", marginBottom: 11 }}>
              <Button type="primary" onClick={() => setIsModalVisible(true)}>
                Create Claim
              </Button>
            </div>
        </div>
        <Input
          placeholder="Search claim"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
        <GenericTable data={claims} columnsConfig={columnsConfig} loading={loading}
        pagination={{
          current: metaData.page || 1,
          pageSize: metaData.limit || 2,
          total: metaData.total || 0,
           onChange: (page, pageSize) => {
            setCurrentPage(page);
            dispatch(fetchClaimsRequest({ page, limit: pageSize, search: searchTerm }));
          },
        }}  />
        {isModalVisible && (
          <GenericDrawer
            isVisible={isModalVisible}
            handleCancel={() => {
              setIsModalVisible(false);
              setEditingClaim(null);
            }}
            title={
              <span style={{display : "flex",alignItems:"center"}}>
                <IconReport style={{ color: "white", marginRight: "8px" }} />
                {editingClaim ? "Edit Claim" : "Create Claim"}
              </span>
            }
            inputs={claimModalInputs}
            onSubmit={handleCreateOrEdit}
            predefinedData={editingClaim || {}}
          />
        )}
        {isViewModalVisible && (
          <GenericViewModal
            isVisible={isViewModalVisible}
            handleCancel={() => setIsViewModalVisible(false)}
            title={
              <span style={{display : "flex",alignItems:"center"}}>
                <IconReport style={{ color: "white", marginRight: "8px" }} />
                View Claim
              </span>
            }
            data={viewingClaim}
            footerButtons={["Close"]}
            onButtonClick={() => setIsViewModalVisible(false)}
          />
        )}
      </div>
    </div>
  );
};

export default ClaimPage;
